import React from 'react';
import { useLanguage } from '@contexts/LanguageContext';
import './StatusBadge.scss';

export const StatusBadge = ({ model, type = 'borrowing', className = '' }) => {
    const { t } = useLanguage();
    const status = model?.current_borrowing?.status || model?.status;
    const is_available = model?.is_available;

    const getStatusInfo = (status, type) => {
        // Borrowing status mapping
        if (type === 'borrowing') {
            const statusMap = {
                'reserved': {
                    text: t('borrowingView.status.reserved'),
                    className: 'status-reserved'
                },
                'reservation_active': {
                    text: t('borrowingView.status.reservationActive'),
                    className: 'status-reservation-active'
                },
                'reservation_expired': {
                    text: t('borrowingView.status.reservationExpired'),
                    className: 'status-reservation-expired'
                },
                'borrowed_active': {
                    text: t('borrowingView.status.borrowedActive'),
                    className: 'status-borrowed-active'
                },
                'overdue': {
                    text: t('borrowingView.status.overdue'),
                    className: 'status-overdue'
                },
                'returned': {
                    text: t('borrowingView.status.returned'),
                    className: 'status-returned'
                },
                'pending_validation': {
                    text: t('borrowingView.status.pendingValidation'),
                    className: 'status-pending-validation'
                },
                'validation_rejected': {
                    text: t('borrowingView.status.validationRejected'),
                    className: 'status-validation-rejected'
                }
            };

            return statusMap[status] || (
                is_available ?
                { text: t('borrowingView.status.available'), className: 'status-available' } :
                { text: t('borrowingView.status.unavailable'), className: 'status-unavailable' }
            );
        }

        // Consumption status mapping
        if (type === 'consumption') {
            return {
                text: t('consumption.status', 'Consommé'),
                className: 'status-consumption'
            };
        }

        // Refill status mapping
        if (type === 'refill') {
            return {
                text: t('refill.status', 'Rechargé'),
                className: 'status-refill'
            };
        }

        // Reservation status mapping
        if (type === 'reservation') {
            return {
                text: t('reservation.status', 'Réservé'),
                className: 'status-reserved'
            };
        }

        // Default fallback for other types
        return { text: status, className: 'status-unknown' };
    };

    const statusInfo = getStatusInfo(status, type);

    return (
        <div className={`status-badge ${statusInfo.className} ${className}`}>
            {statusInfo.text}
        </div>
    );
};

export default StatusBadge;
